import styles from "./toolbox-components.module.css";

interface ToolboxComponentSectionProps {
  title?: string;
  children: React.ReactNode;
  isEnabled?: boolean; // Optional prop to indicate if the section is enabled
}

export const ToolboxComponentSection = (
  props: ToolboxComponentSectionProps
) => {
  return (
    <div
      className={styles.sectionContainer}
      style={{ opacity: props.isEnabled ?? true ? 1 : 0.5 }}
    >
      {props.title && (
        <div className={styles.sectionTitleContainer}>
          <span className={styles.sectionTitle}>{props.title}</span>
        </div>
      )}
      {props.children}
    </div>
  );
};

interface ToolboxSectionDividerProps {
  whitespaceOnly?: boolean;
  padding?: number;
}
export const ToolboxSectionDivider = ({
  whitespaceOnly = false,
  padding = 16,
}: ToolboxSectionDividerProps) => {
  return (
    <div
      className={
        whitespaceOnly ? styles.sectionDividerWhitespace : styles.sectionDivider
      }
      style={{
        margin: `${padding}px 0`,
      }}
    />
  );
};
